var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vToast),expression:"vToast"}],staticClass:"lp-toast-bg"},[_c('div',{staticClass:"lp-toast"},[_c('div',[_vm._v(_vm._s(_vm.msg))]),_c('div',[_vm._v(_vm._s(_vm.percent)+"%")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }